<template>
  <div class="width100 s_po_re" :style="{'background':!data.params.imgUrl ? '#F85724':('url('+info.picdomain+data.params.imgUrl+') center center/cover no-repeat'),'height':'200px'}">
    <div class="s_flex_bian_c p-t-15 p-l-15">
      <div class="s_flex_ali">
        <img class="width-45 height-45" src="@/assets/images/user.png" alt="">
        <p class="fz-18 s_cfff s_font_b m-l-10">会员昵称</p>
      </div>
      <div class="s_flex_center p-l-15 p-r-15 height-28" style="background-color: rgba(225,225,225,.5);border-top-left-radius: 14px;border-bottom-left-radius: 14px;"> 
        <p class="s_cfff m-r-5">积分说明</p>
        <QuestionCircleOutlined style="color:#fff"/>
      </div>
    </div>
    <div class="s_flex_center m-t-10">
      <img class="width-18 height-18" src="@/assets/images/jifen1.png" alt="">
      <p class="fz-40 s_font_b s_cfff">15451</p>
    </div>
    <div class="s_flex_bian_c height-43 width100" style="background-color: rgba(225,225,225,.5);position: absolute;bottom: 0;left: 0;">
      <div class="width50 s_flex_center">
        <img class="width-18 height-18" src="@/assets/images/jifen2.png" alt="">
        <p class="fz-15 s_cfff m-l-5">去兑换</p>
      </div>
      <div class="height-30 s_bl1_cf4f"></div>
      <div class="width50 s_flex_center">
        <img class="width-18 height-18" src="@/assets/images/jifen3.png" alt="">
        <p class="fz-15 s_cfff m-l-5">积分明细</p>
      </div>
    </div>
  </div>
</template>
<script>
  import { QuestionCircleOutlined  } from '@ant-design/icons-vue';
  import store from "@/store";
  import { ref, toRefs, reactive } from "vue";
  export default {
    components: { QuestionCircleOutlined },
    props: { data: Object },
    name: "header",
    setup(props) {
      const state = reactive({
        info: store.state.user.info,
      });
      return {
        ...toRefs(state)
      };
    }
  };
</script>
<style>

</style>